<template>
  <w-row>
    <w-column
      cols="12"
      class="d-flex"
    >
      <w-form-autocomplete-lazy
        :label="$t('Common.processDeviation')"
        item-value="id"
        :item-text="deviationStatus ? getItemText : undefined"
        path="deviations"
        :value="internalValue"
        :cache-items="false"
        :api-get-response-item-text="getItemText"
        readonly
        @input="handleChange"
      />
      <w-export-button 
        v-if="deviationStatus" 
        @click="navigateToDeviation"
      >
        <template #tooltip>
          {{ $t('ProcessDeviations.sentences.navigateToDeviation') }}n
        </template>
      </w-export-button>
    </w-column>

    <w-column
      cols="12"
      md="12"
    >
      <w-read-only-text-field
        v-model="deviationStatus"
        label="Status"
      />
    </w-column>
  </w-row>
</template>

<script>
//import dataMixin from '@/mixins/data-mixin';
import dateFormatter from '@/services/formatter_services/date-formatter';
import { mapActions } from 'vuex';
import deviationService from '@/modules/process_deviations/services/deviation-service';

export default {
  name: 'DeviationUnit',
  props: {
    value: { type: Array, default: () => [] }
  },
  data(){
    return {
      deviation: undefined,
    }
  },
  computed: {
    deviationStatus() {
      return this.deviation?.data?.status?.data?.label;
    },
    internalValue(){
      return this.value == undefined || this.value.length == 0 ? undefined : this.value[0]
    }
  },
  methods: {
    ...mapActions('routingHistory', ['setIntentionalUnusualForwarding']),
    formatDate(date) {
      return dateFormatter.formatDateToLocaleDateString(date?.substring(0,16));
    },
    navigateToDeviation() {
      this.setIntentionalUnusualForwarding(true);
      try {
        const routeData = this.$router.resolve({
          name: 'ProcessDeviationForm',
          params: { id: this.value.toString() },
        });
        window.open(routeData.href, '_blank')
      } catch { }      
    },
    handleChange(deviation) {
      this.$emit('input', [deviation])
    },
    getItemText(item){
      let createdAt = item?.data?.createdAt ?? item?.createdAt;
      let matchCode = item?.data?.project?.data?.matchCode ?? item?.projectMatchCode;
      return `${matchCode} - ${this.formatDate(createdAt)}`
    },
  },
  watch: {
    internalValue: {
      async handler(){
        if (this.internalValue && this.internalValue != null) {
          let response = await deviationService.getDeviation(this.internalValue);
          this.deviation = response.data;
        }
        else this.deviation = {}
      },
      immediate: true
    }
  }
}
</script>
